<template>
    <a
        :href="pdfPermalink"
        target="_blank"
        class="btn btn-light mr-4 dm-btn-min-width"
    >
        <i class="icon-lg las la-file-pdf"></i>
        {{ translate("Presentation as PDF") }}
    </a>
</template>

<script>
export default {
    components: {},

    props: ["submission_id"],

    computed: {
        pdfPermalink() {
            return "/submission/" + this.submission_id + "/pdf";
        },
    },
};
</script>
